import { navigate } from '../router.js';
import { isWebAuthnAvailable } from '../webauthn.js';
import { lucideIcons } from '../app.js';

export function renderSetupCredential(container) {
  if (!isWebAuthnAvailable()) {
    navigate('#/setup-password');
    return;
  }

  container.innerHTML = `
    <div class="login-card">
      <div class="logo">
        <svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-setup-cred" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-setup-cred)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-setup-cred)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-setup-cred)" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="brand">Blind<span>Keep</span></div>
      </div>
      <p style="color:var(--text-secondary);margin-bottom:1.5rem;text-align:center">
        Choose how to secure your vault. A passkey with biometrics gives you passwordless access.
      </p>
      <div style="display:flex;gap:1rem;flex-wrap:wrap">
        <button id="choose-passkey" class="btn btn-primary"><i data-lucide="fingerprint" style="width:16px;height:16px"></i> Use Passkey</button>
        <button id="choose-password" class="btn btn-secondary" style="width:100%"><i data-lucide="key" style="width:16px;height:16px"></i> Set Password</button>
      </div>
    </div>
  `;
  lucideIcons();

  document.getElementById('choose-passkey').onclick = () => navigate('#/setup-passkey');
  document.getElementById('choose-password').onclick = () => navigate('#/setup-password');
}
